import { Navigate, useSearchParams } from 'react-router-dom'
import { isAuth } from '../utils/auth'
import { useContext, useEffect, useState } from 'react'
import { NavContext } from '../context/global_context'
import { getLoginConfig } from './login/api'
import CognitoLogin from './login/CognitoLogin'
import NativeLogin from './login/NativeLogin'
import { wasJustLoggedOut } from './login/loggedOut'

const Login = () => {
  const [, dispatch] = useContext(NavContext)
  const [searchParams] = useSearchParams()
  const [isRedirect, setIsRedirect] = useState(null)
  const [config, setConfig] = useState(null)
  // Arriving here straight from logout. Not cleared here: the layout's sign-in
  // check hides and re-shows this page right after logout, so it mounts twice -
  // the flag is cleared once the user leaves the page (Layout)
  const [loggedOut] = useState(wasJustLoggedOut)
  const notice = loggedOut ? 'auth.loggedOutNotice' : null

  useEffect(() => {
    dispatch({ type: 'header', data: { show_back_btn: false } })
    redirectToAuthenticate()
    loadConfig()
  }, [])

  const loadConfig = async () => {
    const res = await getLoginConfig()
    // A failed config call falls back to the AT form, which is what this page
    // showed before it knew about Cognito at all.
    setConfig(res?.status ? res : { mode: 'native', custom_login: false, providers: [] })
  }

  const redirectToAuthenticate = () => {
    // isAuth() rather than a bare truthy check: the two used to disagree about a
    // token stored as the literal string "undefined", which is falsy to isAuth
    // and truthy here - so this page bounced straight back to a route the guard
    // would refuse, and the two kept handing the browser to each other.
    if (isAuth()) {
      if (!searchParams.get('next')) {
        setIsRedirect('/vehicles')
      } else {
        setIsRedirect(searchParams.get('next'))
      }
    }
  }

  if (isRedirect) {
    return <Navigate to={isRedirect} />
  }
  // Nothing until the host's sign-in method is known, so a Cognito host never
  // flashes the AT form (or vice versa)
  if (!config) {
    return null
  }
  // Both pages share the same card; the Cognito one adds password reset and
  // identity providers, the AT one is email and password only.
  if (config?.mode === 'cognito' && config?.custom_login) {
    return <CognitoLogin providers={config?.providers || []} initialNotice={notice} />
  }
  return <NativeLogin notice={notice} />
}

export default Login
